<template>
  <div class="container">
    <div class="form-content">
      <ion-item>
        <ion-label position="stacked">Izen-abizenak</ion-label>
        <ion-input
          :value="name"
          @ionInput="name = $event.target.value"
        ></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Emaila</ion-label>
        <ion-input
          :value="email"
          @ionInput="email = $event.target.value"
        ></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Telefonoa</ion-label>
        <ion-input
          :value="phone"
          @ionInput="phone = $event.target.value"
        ></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Helbidea</ion-label>
        <ion-textarea
          :value="address"
          @ionInput="address = $event.target.value"
        >
        </ion-textarea>
      </ion-item>

      <div class="gps-fields">
        <div v-if="mapboxToken" class="place-search">
          <ion-item>
            <ion-label position="stacked">Lekua bilatu</ion-label>
            <ion-input
              :value="placeSearch"
              placeholder="Helbidea edo lekua"
              @ionInput="placeSearch = $event.target.value"
              @keydown.enter="searchPlaces"
            ></ion-input>
          </ion-item>

          <ion-button
            @click="searchPlaces"
            expand="block"
            mode="ios"
            color="light"
            size="medium"
            :disabled="placeSearching || !placeSearch"
          >
            {{ placeSearching ? "Bilatzen..." : "Bilatu" }}
          </ion-button>

          <ion-list v-if="placeResults.length" class="place-results">
            <ion-item
              v-for="place in placeResults"
              :key="place.id"
              button
              @click="selectPlace(place)"
            >
              <ion-label>
                <strong>{{ place.text }}</strong>
                <p>{{ place.place_name }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>

        <ion-item>
          <ion-label position="stacked">GPS latitudea</ion-label>
          <ion-input
            type="number"
            :value="gpsLat"
            @ionInput="gpsLat = $event.target.value"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">GPS longitudea</ion-label>
          <ion-input
            type="number"
            :value="gpsLon"
            @ionInput="gpsLon = $event.target.value"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Erradioa (metroak)</ion-label>
          <ion-input
            type="number"
            :value="gpsRadius"
            @ionInput="gpsRadius = $event.target.value"
          ></ion-input>
        </ion-item>

        <ion-button
          @click="useCurrentLocation"
          expand="block"
          mode="ios"
          color="light"
          size="medium"
        >
          Uneko kokapena erabili
        </ion-button>

        <div v-if="mapboxToken" ref="gpsMapEl" class="gps-map"></div>

        <iframe
          v-else-if="gpsLat && gpsLon"
          class="gps-map"
          :src="mapUrl"
          loading="lazy"
        ></iframe>
      </div>
    </div>

    <div class="buttons-footer">
      <ion-button @click="saveHandle" expand="block" mode="ios" size="medium">
        Gorde
      </ion-button>

      <ion-button
        v-if="id"
        @click="deleteHandle"
        expand="block"
        mode="ios"
        color="danger"
        size="medium"
      >
        Ezabatu
      </ion-button>
    </div>

    <messages v-if="toast" :toast="toast" @closeToast="closeToast"></messages>
  </div>
</template>

<script>
import {
  IonItem,
  IonLabel,
  IonInput,
  IonTextarea,
  IonButton,
  IonList,
  loadingController,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import errors from "@/middlewares/errors.js";
import Messages from "@/components/Messages.vue";

import axios from "axios";
import {
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
  nextTick,
  watch,
} from "vue";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { safeDismiss } from "@/utils/overlays";
export default {
  name: "ClientForm",
  components: {
    IonItem,
    IonLabel,
    IonInput,
    IonTextarea,
    IonButton,
    IonList,
    Messages,
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const id = ref(null);
    const name = ref(null);
    const email = ref(null);
    const phone = ref(null);
    const address = ref(null);
    const gpsLat = ref(null);
    const gpsLon = ref(null);
    const gpsRadius = ref(60);
    const gpsMapEl = ref(null);
    const gpsMap = ref(null);
    const gpsMarker = ref(null);
    const placeSearch = ref("");
    const placeSearching = ref(false);
    const placeResults = ref([]);
    const mapboxToken =
      process.env.VUE_APP_MAPBOX_TOKEN ||
      "pk.eyJ1IjoiYXNpZXJtdXNhIiwiYSI6ImNrMzRkaDByeDBvZ24zbm1xa21mc2w0Zm4ifQ.7vunOoH1vCyWY7kufTJBoA";
    const toast = ref(null);

    onMounted(() => {
      if (props.client) {
        id.value = props.client.id;
        name.value = props.client.name;
        email.value = props.client.email;
        phone.value = props.client.phone;
        address.value = props.client.address;
        gpsLat.value = props.client.gps_lat;
        gpsLon.value = props.client.gps_lon;
        gpsRadius.value = props.client.gps_radius_m || 60;
      }

      nextTick(() => initGpsMap());
    });

    const mapUrl = computed(() => {
      const lat = Number(gpsLat.value);
      const lon = Number(gpsLon.value);
      const delta = 0.004;

      return `https://www.openstreetmap.org/export/embed.html?bbox=${
        lon - delta
      },${lat - delta},${lon + delta},${
        lat + delta
      }&layer=mapnik&marker=${lat},${lon}`;
    });

    const closeToast = () => {
      toast.value = null;
    };

    const getMapCenter = () => {
      const lat = Number(gpsLat.value);
      const lon = Number(gpsLon.value);

      if (Number.isFinite(lat) && Number.isFinite(lon)) {
        return [lon, lat];
      }

      return [-2.6846917, 43.3103783];
    };

    const setGpsCoords = (lat, lon) => {
      gpsLat.value = Number(lat).toFixed(7);
      gpsLon.value = Number(lon).toFixed(7);
      if (!gpsRadius.value) gpsRadius.value = 60;
    };

    const syncMarker = () => {
      if (!gpsMap.value || !gpsMarker.value) return;

      const lat = Number(gpsLat.value);
      const lon = Number(gpsLon.value);

      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;

      gpsMarker.value.setLngLat([lon, lat]);
      syncRadiusCircle();
    };

    const circleGeoJson = (lat, lon, radiusMeters) => {
      const points = 64;
      const coords = [];
      const earth = 6371000;
      const latRad = (lat * Math.PI) / 180;
      const lonRad = (lon * Math.PI) / 180;
      const distance = Number(radiusMeters || 60) / earth;

      for (let i = 0; i <= points; i++) {
        const bearing = (i * 2 * Math.PI) / points;
        const pointLat = Math.asin(
          Math.sin(latRad) * Math.cos(distance) +
            Math.cos(latRad) * Math.sin(distance) * Math.cos(bearing),
        );
        const pointLon =
          lonRad +
          Math.atan2(
            Math.sin(bearing) * Math.sin(distance) * Math.cos(latRad),
            Math.cos(distance) - Math.sin(latRad) * Math.sin(pointLat),
          );

        coords.push([(pointLon * 180) / Math.PI, (pointLat * 180) / Math.PI]);
      }

      return {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [coords],
        },
      };
    };

    const syncRadiusCircle = () => {
      if (!gpsMap.value) return;

      const lat = Number(gpsLat.value);
      const lon = Number(gpsLon.value);

      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;

      const source = gpsMap.value.getSource("gps-radius");
      const data = circleGeoJson(lat, lon, gpsRadius.value || 60);

      if (source) {
        source.setData(data);
      }
    };

    const moveMapToGps = (zoom = 16) => {
      if (!gpsMap.value) return;

      const lat = Number(gpsLat.value);
      const lon = Number(gpsLon.value);

      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;

      gpsMap.value.flyTo({
        center: [lon, lat],
        zoom,
      });
    };

    const normalizeMapboxPlaces = (features) =>
      (features || []).map((feature) => ({
        id: `mapbox-${feature.id}`,
        text: feature.text || feature.place_name || "Lekua",
        place_name: feature.place_name || feature.text || "",
        center: feature.center,
      }));

    const normalizePhotonPlaces = (features) =>
      (features || [])
        .map((feature) => {
          const [lon, lat] = feature.geometry?.coordinates || [];
          const properties = feature.properties || {};
          const details = [
            properties.street,
            properties.housenumber,
            properties.city || properties.town || properties.village,
            properties.state,
            properties.country,
          ].filter(Boolean);

          return {
            id: `photon-${properties.osm_id || `${lon}-${lat}`}`,
            text: properties.name || properties.street || "Lekua",
            place_name: details.join(", "),
            center: [lon, lat],
          };
        })
        .filter((place) => {
          const [lon, lat] = place.center || [];
          return Number.isFinite(Number(lat)) && Number.isFinite(Number(lon));
        });

    const searchMapboxPlaces = async (query, center) => {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          query,
        )}.json`,
        {
          params: {
            access_token: mapboxToken,
            autocomplete: true,
            country: "es",
            language: "eu,es",
            limit: 5,
            proximity: `${center[0]},${center[1]}`,
            types: "poi,address,place,locality,neighborhood",
          },
        },
      );

      return normalizeMapboxPlaces(response.data?.features);
    };

    const searchPhotonPlaces = async (query, center) => {
      const response = await axios.get("https://photon.komoot.io/api/", {
        params: {
          q: query,
          lang: "es",
          limit: 5,
          lon: center[0],
          lat: center[1],
        },
      });

      return normalizePhotonPlaces(response.data?.features);
    };

    const searchPlaces = async () => {
      const query = String(placeSearch.value || "").trim();

      if (!query || placeSearching.value) return;

      placeSearching.value = true;
      placeResults.value = [];

      try {
        const center = getMapCenter();
        let results = await searchMapboxPlaces(query, center);

        if (!results.length) {
          results = await searchPhotonPlaces(query, center);
        }

        placeResults.value = results;

        if (!placeResults.value.length) {
          toast.value = {
            type: "warning",
            message: "Ez da lekurik aurkitu",
          };
        }
      } catch (error) {
        toast.value = {
          type: "danger",
          message: "Ezin izan da lekua bilatu",
        };
      } finally {
        placeSearching.value = false;
      }
    };

    const selectPlace = (place) => {
      const [lon, lat] = place.center || [];

      if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lon))) {
        return;
      }

      setGpsCoords(lat, lon);
      placeSearch.value = place.place_name || place.text || "";
      placeResults.value = [];
      syncMarker();
      moveMapToGps();
    };

    const initGpsMap = () => {
      if (!mapboxToken || !gpsMapEl.value || gpsMap.value) return;

      mapboxgl.accessToken = mapboxToken;

      gpsMap.value = new mapboxgl.Map({
        container: gpsMapEl.value,
        style: "mapbox://styles/mapbox/streets-v12",
        center: getMapCenter(),
        zoom: gpsLat.value && gpsLon.value ? 16 : 12,
      });

      gpsMap.value.addControl(new mapboxgl.NavigationControl(), "top-right");

      gpsMarker.value = new mapboxgl.Marker({
        color: "#1f7a4d",
        draggable: true,
      })
        .setLngLat(getMapCenter())
        .addTo(gpsMap.value);

      gpsMarker.value.on("dragend", () => {
        const coords = gpsMarker.value.getLngLat();
        setGpsCoords(coords.lat, coords.lng);
      });

      gpsMap.value.on("click", (event) => {
        setGpsCoords(event.lngLat.lat, event.lngLat.lng);
        gpsMarker.value.setLngLat(event.lngLat);
      });

      gpsMap.value.on("load", () => {
        gpsMap.value.addSource("gps-radius", {
          type: "geojson",
          data: circleGeoJson(
            Number(getMapCenter()[1]),
            Number(getMapCenter()[0]),
            gpsRadius.value || 60,
          ),
        });
        gpsMap.value.addLayer({
          id: "gps-radius-fill",
          type: "fill",
          source: "gps-radius",
          paint: {
            "fill-color": "#1f7a4d",
            "fill-opacity": 0.18,
          },
        });
        gpsMap.value.addLayer({
          id: "gps-radius-line",
          type: "line",
          source: "gps-radius",
          paint: {
            "line-color": "#1f7a4d",
            "line-width": 2,
          },
        });
        gpsMap.value.resize();
        syncRadiusCircle();
      });

      setTimeout(() => {
        if (gpsMap.value) gpsMap.value.resize();
      }, 400);
    };

    const useCurrentLocation = () => {
      if (!navigator.geolocation) {
        toast.value = {
          type: "danger",
          message: "Gailuak ez du kokapena onartzen",
        };
        return true;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          gpsLat.value = position.coords.latitude.toFixed(7);
          gpsLon.value = position.coords.longitude.toFixed(7);
          if (!gpsRadius.value) gpsRadius.value = 60;
          syncMarker();
          if (gpsMap.value) {
            moveMapToGps();
          }
        },
        () => {
          toast.value = {
            type: "danger",
            message: "Ezin izan da kokapena lortu",
          };
        },
      );
    };

    watch([gpsLat, gpsLon], syncMarker);
    watch(gpsRadius, syncRadiusCircle);

    onBeforeUnmount(() => {
      if (gpsMap.value) {
        gpsMap.value.remove();
      }
    });

    const saveHandle = async () => {
      const loading = await loadingController.create({
        cssClass: "my-custom-class",
        mode: "ios",
      });

      await loading.present();

      let params = {
        id: id.value,
        name: name.value,
        email: email.value,
        phone: phone.value,
        address: address.value,
        gps_lat: gpsLat.value,
        gps_lon: gpsLon.value,
        gps_radius_m: gpsRadius.value || 60,
      };
      if (!name.value || !email.value || !phone.value || !address.value) {
        toast.value = {
          type: "danger",
          message: "Bete beharrezko eremuak",
        };
        safeDismiss(loading);
        return true;
      }

      let method = "create";
      if (id.value) {
        method = "update";
      }
      axios
        .post(`${method}`, params)
        .then(async (res) => {
          if (res.data.error) {
            toast.value = {
              type: "danger",
              message: `Erroreak errepasatu:
                ${errors(res.data.error)}`,
            };
            safeDismiss(loading);
            return true;
          }

          if (id.value) store.dispatch("_clientReload", id.value);
          store.commit("_RESET_CLIENTS", "change"); // reset the list

          toast.value = {
            type: "success",
            message: "Bezeroaren datuak gorde dira",
          };
          safeDismiss(loading);

          // After saving the client, re-evaluate active work sessions
          // for this client and close those that are outside the new radius
          // or exceed the inactivity threshold.
          try {
            if (id.value) {
              await evaluateAndCloseSessions(id.value);
            }
          } catch (err) {
            // non-blocking: show a toast but don't fail the save
            toast.value = {
              type: "warning",
              message: "Egiaztatze prozesuan arazo bat izan da (saioak).",
            };
          }
        })
        .catch(() => {
          toast.value = {
            type: "danger",
            message: `Zerbitzariko errore bat gertatu da...`,
          };
          safeDismiss(loading);
        });
    };

    const deleteHandle = async () => {
      const loading = await loadingController.create({
        mode: "ios",
      });

      let del = confirm("Bezeroa eta bere lan guztiak ezabatu nahi al dituzu?");

      if (!del) return true;

      await loading.present();

      axios
        .delete(`client/${id.value}`)
        .then(() => {
          store.commit("_RESET_CLIENTS", "change"); // reset the list
          store.commit("_RESET_PAYMENTS", true); // reset the list
          store.dispatch("_jobsReload");
          safeDismiss(loading);
          toast.value = {
            type: "success",
            message: "Bezeroa ezabatu da. Berbidalia izango zara...",
          };
          setTimeout(() => {
            router.replace("/clients");
          }, 5000);
        })
        .catch(() => {
          toast.value = {
            type: "danger",
            message: `Zerbitzariko errore bat gertatu da...`,
          };
          safeDismiss(loading);
        });
    };

    // --- Helpers for post-save session evaluation ---
    const distanceMeters = (lat1, lon1, lat2, lon2) => {
      const toRad = (v) => (v * Math.PI) / 180;
      const R = 6371000; // meters
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
          Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    };

    const unwrapList = (payload, key) => {
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload?.[key])) return payload[key];
      if (Array.isArray(payload?.data)) return payload.data;
      return [];
    };

    const evaluateAndCloseSessions = async (clientId) => {
      if (!clientId) return;

      // fetch work sessions for the client
      const sessionsRes = await axios
        .get(`/work-sessions`, {
          params: { client_id: clientId },
        })
        .catch(() => ({ data: [] }));

      const sessions = unwrapList(sessionsRes.data, "sessions").map((s) => ({
        ...s,
        isActive: s.isActive ?? s.is_active ?? !s.endedAt,
        updatedAt: s.updatedAt || s.updated_at,
      }));

      const activeSessions = sessions.filter((s) => s.isActive);
      if (!activeSessions.length) return;

      // fetch trackers to obtain last known positions
      const trackersRes = await axios
        .get("/trackers")
        .catch(() => ({ data: [] }));
      const trackers = unwrapList(trackersRes.data, "trackers").reduce(
        (acc, t) => {
          const key = (t.imei || t.id || "").toString();
          acc[key] = t;
          return acc;
        },
        {},
      );

      // fetch gps settings for inactivity fallback
      const settingsRes = await axios
        .get("/gps/settings")
        .catch(() => ({ data: null }));
      const autoHours =
        settingsRes.data?.settings?.auto_close_after_hours || null;

      let closedCount = 0;

      for (const session of activeSessions) {
        try {
          const imei =
            session.imei || session.device_imei || session.imei_id || "";
          const tracker = trackers[imei] || null;

          let shouldClose = false;

          if (
            tracker &&
            Number.isFinite(Number(tracker.lat)) &&
            Number.isFinite(Number(tracker.lon))
          ) {
            const lat = Number(gpsLat.value);
            const lon = Number(gpsLon.value);
            const tlat = Number(tracker.lat);
            const tlon = Number(tracker.lon);
            if (Number.isFinite(lat) && Number.isFinite(lon)) {
              const dist = distanceMeters(lat, lon, tlat, tlon);
              if (dist > Number(gpsRadius.value || 60)) {
                shouldClose = true;
              }
            }
          } else if (autoHours && session.updatedAt) {
            const updatedMs = new Date(session.updatedAt).getTime();
            if (!Number.isNaN(updatedMs)) {
              const ageMs = Date.now() - updatedMs;
              if (ageMs > autoHours * 3600 * 1000) {
                shouldClose = true;
              }
            }
          }

          if (shouldClose && session.id) {
            // mark session as ended instead of deleting
            await axios
              .patch(`/work-sessions/${session.id}`, {
                ended_at: new Date().toISOString(),
              })
              .catch(() => {});
            closedCount += 1;
          }
        } catch (e) {
          // ignore per-session errors
        }
      }

      if (closedCount) {
        toast.value = {
          type: "success",
          message: `${closedCount} saio itxi dira bezeroaren irradiotik kanpo geratu direlako`,
        };
        // trigger store refreshes used elsewhere
        store.dispatch("_clientReload", clientId).catch(() => {});
      }
    };

    return {
      saveHandle,
      deleteHandle,
      id,
      name,
      email,
      phone,
      address,
      gpsLat,
      gpsLon,
      gpsRadius,
      gpsMapEl,
      placeSearch,
      placeSearching,
      placeResults,
      mapboxToken,
      mapUrl,
      toast,
      closeToast,
      searchPlaces,
      selectPlace,
      useCurrentLocation,
    };
  },
};
</script>

<style lang="scss">
.container {
  padding: 20px 20px calc(96px + env(safe-area-inset-bottom));
}

.form-content {
  margin: 0 0 30px 0;
}

.buttons-footer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 10px;

  ion-button {
    width: 100%;
    margin: 0;
  }
}

.gps-fields {
  margin-top: 20px;
}

.place-search {
  display: grid;
  gap: 10px;
  margin-bottom: 16px;
}

.place-search ion-button {
  margin: 0;
}

.place-results {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(20, 35, 45, 0.12);

  ion-item {
    --padding-start: 14px;
    --inner-padding-end: 14px;
  }

  p {
    margin: 4px 0 0;
    color: var(--ion-color-medium);
    white-space: normal;
  }
}

.gps-map {
  width: 100%;
  height: 220px;
  border: 0;
  margin-top: 12px;
}
</style>
